import Enumerable from "linq";

export class Logger {
  constructor(maxCount: number = null, formatter: (l: { timeStamp: Date, log: string }) => string = null) {
    this._maxCount = maxCount
      ? maxCount
      : Logger._default.maxCount;
    this._formatter = formatter
      ? formatter
      : Logger._default.formatter;
  }

  private readonly _maxCount: number;
  private readonly _formatter: (l: { timeStamp: Date, log: string }) => string;
  private readonly _logs: { timeStamp: Date, log: string }[] = [];
  private static readonly _default = {
    maxCount: 200,
    formatter: (l: { timeStamp: Date, log: string }) => l.timeStamp.toString() + ": " + l.log,
  };

  push(log: string): void {
    this._logs.push({
      timeStamp: new Date(),
      log,
    });
    if (this._maxCount < this._logs.length) {
      this._logs.shift(); // 先頭のログを削除.
    }
  }

  toString(isDescending: boolean = false): string {
    return Enumerable.from(isDescending ? this._logs.reverse() : this._logs)
      .select(l => this._formatter(l))
      .toArray()
      .join("\n");
  }
}
